module.exports = __webpack_public_path__ + "img/robot-icon.0e0164bb.png";